// removed by extract-text-webpack-plugin
module.exports = {"rewardContent":"rewardContent__32nQV","rewardDetail":"rewardDetail__1pRZO","rewardDes":"rewardDes__2Uxez","rewardCount":"rewardCount__11l6b","rewardImg":"rewardImg__11UlZ"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Reward/index.css
// module id = 1480
// module chunks = 0